// ПЕРВЫЙ ШАГ В КОРЗИНЕ - ЗАКАЗ

function cartOrder() {

  // Оранжевая стрелочка "Подробнее"
  $('.js-more').click(function(){
    $(this).siblings('.js-more-list').slideToggle()
  })



     let counter = document.querySelectorAll('.details__counter')

  // Счётчик
  let minus = document.querySelectorAll('.js-counter__minus'), // плюс и минус у счетчика
      plus = document.querySelectorAll('.js-counter__plus');

  // Проверка на минимальное кол-во товара
  function checkQuantity() {
    for (let i = 0; i < minus.length; i++) {
      if (counter[i].textContent <= 1) {
        minus[i].style.display = 'none';
      } else {
        minus[i].style.display = 'block';
      }
    }
  }

  // Событие нажатия на кнопки счетчика - минус...
  for (let i = 0; i < minus.length; i++) {
    checkQuantity();
    minus[i].addEventListener('click', function () {
      if (counter[i].textContent != 1) // пока товара не минимальное кол-во продолжаем уменьшать
      {
        counter[i].textContent = Number(counter[i].textContent) - 1;
        this.style.display = 'block';
        if (counter[i].textContent == 1) this.style.display = 'none';
      }
    });
  }

  // ...и плюс
  for (let i = 0; i < plus.length; i++) {
    plus[i].addEventListener('click', function () {
      counter[i].textContent = Number(counter[i].textContent) + 1;
      minus[i].style.display = 'block';
    });
  }



  var breadcrumbs = $('.js-breadcrumbs li'); // список хлебных крошек
  $('.js-oneclick-modal__btn').click(function(e){
    e.preventDefault();
    $(window).trigger('goal.main', $(this).parents('form').data());
    $('.js-oneclick-modal__btn').attr('disabled',true)
    var input = new FormData(document.getElementById('oneclick-modal'));
	$('#oneclick-modal').find('.oneclick__alert').hide();
    $.ajax({
      method: "POST",
      url:'/oa/Submit_Fast/',
      data: input,
      processData: false,
      contentType: false,
      dataType:'json'
    }).then((data) => {
		$('#oneclick-modal').find('input').attr('style','');
		if (data.error) {
			$('.js-oneclick-modal__btn').attr('disabled',false);
			$('#oneclick-modal').find('.oneclick__alert').show();
			for (var i = 0; i < data.errors.length; i++) {
				$('#oneclick-modal').find('input[name="'+data.errors[i]+'"]').css('border-bottom-color','FireBrick');
				$('#oneclick-modal').find('input[name="'+data.errors[i]+'"]').css('background','rgba(139,0,0,.2)');
			}
		} else {
			$('.js-order__block').html(data.content);
			$("html, body").animate({
			  scrollTop: 0
			}, 1000);
			$('.js-oneclick-modal__btn').attr('disabled',false)
			$.fancybox.close();
		}
    })
  })

}


export {
  cartOrder
};
